import React, { useState, useContext, useEffect } from 'react';
import { Select, Space } from 'antd';
import { useTranslation } from 'react-i18next';

function LangSelection() {
  const { i18n } = useTranslation();

  const opts = [
    { value: 'en', label: '🇬🇧 English', emoji: '🇬🇧' },
    { value: 'it', label: '🇮🇹 Italiano', emoji: '🇮🇹' }
  ]

  const changeLanguage = (lng) => {
    console.log('Changing language to:', lng);
    i18n.changeLanguage(lng.value);
  };

  return (
    <div className="uppermenu-item">
      <Select 
        size='small'
        options={opts} 
        placeholder="Select Language"
        style={{ width: 120 }}
        value={i18n.resolvedLanguage}
        labelInValue
        onChange={changeLanguage}
      />
    </div>
  );
}

export default LangSelection;